import posthog from 'posthog-js'

export const initTracking = function () {
  posthog.init(process.env.POSTHOG_KEY, {
    api_host: process.env.POSTHOG_HOST
  })
}

export const trackEvent = function (event, payload) {
  posthog.capture(event, payload)
}

export const identifyUser = function (userId) {
  posthog.identify(`user_${userId}`, { usedConsumerSite: true })
}

export const reset = function () {
  posthog.reset()
}



// WEBPACK FOOTER //
// ./src/services/posthog.js